<template>
    <v-dialog
        :value="isOpen"
        scrollable
        persistent
        max-width="800px"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card tile>
            <v-card-title>
                Numery zamówień, których nie udało się dodać
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="page"
                    :items-per-page="5"
                >
                    <template #item.shipmentStatus="{item}">
                        {{ item.status.name }}

                        <v-tooltip v-if="item.overdue" :open-delay="tooltipDelay" top>
                            <template #activator="{on}">
                                <v-icon color="warning" small v-on="on">
                                    mdi-clock-outline
                                </v-icon>
                            </template>
                            <span>Opóźnione</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    text
                    data-sentry-label="Zamknij"
                    color="info"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'NotSentOrdersListDialog',
    mixins: [
        tooltipDelay,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            page: 1,
            headers: [
                {
                    text: 'Numer zamówienia',
                    value: 'fullProductionNumber',
                    sortable: false,
                    width: 200
                },
                {
                    text: 'Numer Klienta',
                    value: 'shopOrderNumber',
                    sortable: false,
                    width: 200
                },
                {
                    text: 'Status',
                    value: 'shipmentStatus',
                    sortable: false,
                    align: 'center'
                },
            ]
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.page = 1
            }, 500)
        },
    }
}
</script>

